import React from "react";
import { sdkIcons } from "../images/developer";
import { RiNextjsFill } from "react-icons/ri";
import { BiLogoNetlify } from "react-icons/bi";
import { FaApple } from "react-icons/fa";
import { SiRubyonrails } from "react-icons/si";

export const sdkList = [
    {
        "name": "React",
        "link": "https://imagekit.io/docs/integration/react",
        "icon": sdkIcons.react,
    },
    {
        "name": "Next.js",
        "link": "https://imagekit.io/docs/integration/nextjs",
        "icon": RiNextjsFill,
    },
    {
        "name": "Angular",
        "link": "https://imagekit.io/docs/integration/angular",
        "icon": sdkIcons.angular,
    },
    {
        "name": "Javascript",
        "link": "https://imagekit.io/docs/integration/javascript",
        "icon": sdkIcons.javascript,
    },
    {
        "name": "Vue.js",
        "link": "https://imagekit.io/docs/integration/vuejs",
        "icon": sdkIcons.vuejs,
    },
    {
        "name": "Netlify",
        "link": "https://imagekit.io/docs/integration/netlify",
        "icon": BiLogoNetlify
    },
    {
        "name": "Android",
        "link": "https://imagekit.io/docs/integration/android",
        "icon": sdkIcons.android,
    },
    {
        "name": "iOS",
        "link": "https://imagekit.io/docs/integration/ios",
        "icon": FaApple
    },
    {
        "name": "Go",
        "link": "https://github.com/imagekit-developer/imagekit-go",
        "icon": sdkIcons.go,
    },
    {
        "name": "Node.js",
        "link": "https://github.com/imagekit-developer/imagekit-nodejs",
        "icon": sdkIcons.nodejs,
    },
    {
        "name": "Python",
        "link": "https://imagekit.io/docs/integration/python",
        "icon": sdkIcons.python,
    },
    {
        "name": "PHP",
        "link": "https://imagekit.io/docs/integration/php",
        "icon": sdkIcons.php,
    },
    {
        "name": ".NET",
        "link": "https://github.com/imagekit-developer/imagekit-dotnet",
        "icon": sdkIcons.dotNet,
    },
    {
        "name": "Java",
        "link": "https://imagekit.io/docs/integration/java",
        "icon": sdkIcons.java,
    },
    {
        "name": "ROR",
        "link": "https://imagekit.io/docs/integration/ruby",
        "icon": SiRubyonrails,
    },
    {
        "name": "Shopify",
        "link": "https://imagekit.io/docs/integration/shopify",
        "icon": sdkIcons.shopify,
    },
    {
        "name": "WordPress",
        "link": "https://imagekit.io/docs/integration/wordpress",
        "icon": sdkIcons.wordpress,
    },
    {
        "name": "Magento",
        "link": "https://imagekit.io/docs/integration/magento",
        "icon": sdkIcons.magento,
    }
]